import type { TripExtension, TripExtensionStatus } from '@/types';

type ChipColor = 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info';

export const EXTENSION_STATUS_LABEL: Record<TripExtensionStatus, string> = {
  REQUESTED: 'Awaiting response',
  ACCEPTED: 'Awaiting payment',
  PAYMENT_PENDING: 'Payment in progress',
  PAID: 'Confirmed',
  DECLINED: 'Declined',
  EXPIRED: 'Expired',
  PAYMENT_FAILED: 'Payment failed',
  CANCELLED: 'Withdrawn',
};

export const EXTENSION_STATUS_COLOR: Record<TripExtensionStatus, ChipColor> = {
  REQUESTED: 'warning',
  ACCEPTED: 'info',
  PAYMENT_PENDING: 'info',
  PAID: 'success',
  DECLINED: 'default',
  EXPIRED: 'default',
  PAYMENT_FAILED: 'error',
  CANCELLED: 'default',
};

export function formatExtensionMoney(amount: number, currency = 'INR') {
  try {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency,
      maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
    }).format(amount);
  } catch {
    return `${currency} ${amount}`;
  }
}

export function formatExtraHours(hours: number) {
  return `${hours} extra hour${hours === 1 ? '' : 's'}`;
}

/** Bookings in these statuses can still gain extra time (server: EXTENDABLE_BOOKING_STATUSES). */
export const EXTENDABLE_BOOKING_STATUSES = ['CONFIRMED', 'UPCOMING', 'IN_PROGRESS'] as const;

export function isExtendableStatus(status: string) {
  return (EXTENDABLE_BOOKING_STATUSES as readonly string[]).includes(status);
}

export function sortExtensionsNewestFirst(items: TripExtension[]) {
  return [...items].sort((a, b) => b.createdAt.localeCompare(a.createdAt));
}
